// import React from "react";
// import "./AmppCertificationSection.css";

// export default function AmppCertificationSection() {
//   return (
//     <section className="ampp-certification container" id="ampp">
//       <div className="section-wrapper">
//         {/* Header */}
//         <div className="text-center mb-4">
//           <h2>What does AMPP Certification mean?</h2>
//           <p className="header-paragraph mx-auto">
//             Corrosion is everywhere, impacting pipelines, bridges, and
//             industrial assets worldwide. While it causes massive losses, it also
//             creates stable, future-proof careers for those with the skills to
//             fight it.
//           </p>
//         </div>

//         {/* Top Section */}
//         <div className="row align-items-center mb-5">
//           {/* Images */}
//           <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 mt-4">
//             <div className="image-grid">
//               <img src="https://previewengine-accl.zoho.in/image/WD/vh8rg1a614dd625714542a78872af97c0dc32?version=1.0&width=2046&height=1536" alt="icci-certification"  />
//             </div>
//           </div>

//           {/* Text */}
//           <div className="col-lg-6 col-md-12 p-5">
//             <h5 className="section-title">Combatting Corrosion Effectively</h5>
//             <p className="section-text">
//               Coatings and Cathodic Protection are two of the most effective
//               ways to slow down the corrosion process. However, their success
//               depends on proper installation and inspection by trained and
//               certified experts, ensuring that protective systems work as
//               intended and extend the life of valuable assets.
//             </p>
//           </div>
//         </div>

//         {/* Bottom Section */}
//         <div className="row align-items-center flex-lg-row flex-column-reverse">
//           {/* Text */}
//           <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
//             <h5 className="section-title">Your Pathway in India</h5>
//             <p className="section-text">
//               The authorised AMPP training licensee in India, delivers
//               world-class programs like CIP, CCI, and CP, designed to equip you
//               with globally recognised qualifications. Whether you’re starting
//               your career or looking to advance, these certifications open doors
//               to high-demand roles in corrosion control and asset protection.
//             </p>
//           </div>

//           {/* Images */}
//           <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
//             <div className="image-grid">
//               <img src="https://previewengine-accl.zoho.in/image/WD/vh8rgd92bd9b88d5f4bd0aa030e0e06e65820?version=1.0&width=2046&height=1536" alt="icci-certifaction"/>
//               {/* <div className="left-images">
//                 <img src={bottomabt} alt="icci-certification" />
//               </div>
//               <div className="right-image">
//                 <img src={abtleft} alt="icci-certification" />
//                 <img src={rightabtimg} alt="icci-certification" />
//               </div> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

import React from "react";
import "./AmppCertificationSection.css";

export default function AmppCertificationSection() {
  return (
    <section className="ampp-certification container" id="ampp">
      <div className="section-wrapper">
        {/* Header */}
        <div className="text-center mb-4">
          <h2>What does AMPP Certification mean?</h2>
          <p className="header-paragraph mx-auto">
            Corrosion is everywhere, impacting pipelines, bridges, and
            industrial assets worldwide. While it causes massive losses, it also
            creates stable, future-proof careers for those with the skills to
            fight it.
          </p>
        </div>

        {/* Top Section */}
        <div className="row align-items-center mb-5">
          {/* Images */}
          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 mt-md-4">
            <div className="image-grid">
              <img src="https://previewengine-accl.zoho.in/image/WD/vh8rg1a614dd625714542a78872af97c0dc32?version=1.0&width=2046&height=1536" alt="icci-certification"  />
            </div>
          </div>

          {/* Text */}
          <div className="col-lg-6 col-md-12 p-md-5">
            <h5 className="section-title">Combatting Corrosion Effectively</h5>
            <p className="section-text">
              Coatings and Cathodic Protection are two of the most effective
              ways to slow down the corrosion process. However, their success
              depends on proper installation and inspection by trained and
              certified experts, ensuring that protective systems work as
              intended and extend the life of valuable assets.
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="row align-items-center flex-lg-row flex-column-reverse">
          {/* Text */}
          <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <h5 className="section-title">Your Pathway in India</h5>
            <p className="section-text">
              ICCI, the authorised AMPP training licensee in India, delivers
              world-class programs like CIP, CCI, and CP, designed to equip you
              with globally recognised qualifications. Whether you’re starting
              your career or looking to advance, these certifications open doors
              to high-demand roles in corrosion control and asset protection.
            </p>
          </div>

          {/* Images */}
          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div className="image-grid">
              <img src="https://previewengine-accl.zoho.in/image/WD/vh8rgd92bd9b88d5f4bd0aa030e0e06e65820?version=1.0&width=2046&height=1536" alt="icci-certifaction"/>
              {/* <div className="left-images">
                <img src={bottomabt} alt="icci-certification" />
              </div>
              <div className="right-image">
                <img src={abtleft} alt="icci-certification" />
                <img src={rightabtimg} alt="icci-certification" />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
